// extracted by mini-css-extract-plugin
module.exports = {"color":"#253754","fade-in":"spinner_fade-in__QPk__"};